'use client';

import { useState } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ScheduledSlotsGrid } from './_components/scheduled-slots-grid.component';
import { ScheduledTabPreview } from './_components/scheduled-tab-preview.component';
import { SearchCardClinicScheduledModal } from './search-card-clinic-scheduled-modal.component';

import { useIsGreaterThan } from '@/hooks/use-is-greather-than.hook';
import { ScheduleType, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

const CARD_SCHEDULED_DAYS = 3;

interface SearchCardClinicTabScheduledProps {
  schedule: SearchPartnerData;
}

export function SearchCardClinicTabScheduled({ schedule }: SearchCardClinicTabScheduledProps) {
  const isWideScreen = useIsGreaterThan('xl');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scheduleId = schedule.schedulesTypes[ScheduleType.SCHEDULED]?.[0]?.id;

  if (isWideScreen) {
    return (
      <div data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_TAB_SCHEDULED}>
        <ScheduledSlotsGrid
          scheduleId={scheduleId}
          limitDays={CARD_SCHEDULED_DAYS}
          onSeeMore={() => setIsModalOpen(true)}
        />
        <SearchCardClinicScheduledModal
          scheduleId={scheduleId}
          schedule={schedule}
          open={isModalOpen}
          onOpenChange={setIsModalOpen}
        />
      </div>
    );
  }

  return <ScheduledTabPreview schedule={schedule} />;
}
